import { faExclamationCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { Fragment, useState, useContext } from "react";
import {
  Alert,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Table,
} from "reactstrap";
/* import Flex from '../../common/Flex';
import PageHeader from '../../common/PageHeader';
import ButtonIcon from '../../UI/buttons/ButtonIcon';
import { isIterableArray } from '../../UI/preloading/PreloadState';
import CreateCurrencyModal from './components/CreateCurrencyModal';
import CreateExhangeRateModal from './components/CreateExchangeRateModal';
import useSWRFetchPagination from '../../../helpers/hooks/useSWRFetchPagination'
import { findAllCurrencies, findAllExchangeRates } from '../../../helpers/api/currency'; */
import CurrencyRow from "./components/CurrencyRow";
/* import FullPagination from '../../common/pagination/FullPagination';
import { Message, Or, PreloadState } from '../../UI/preloading/PreloadState'; */
import ExchangeRateRow from "./components/ExchageRateRow";
import {
  findAllCurrencies,
  findAllExchangeRates,
} from "../../helpers/api/currency";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import PageHeader from "../common/PageHeader";
import { isIterableArray } from "../../helpers/utils";
import Flex from "../common/Flex";
import ButtonIcon from "../common/ButtonIcon";
import { Message, Or, PreloadState } from "../UI/preloading/PreloadState";
import FullPagination from "../common/pagination/FullPagination";
import CreateExhangeRateModal from "./components/CreateExchangeRateModal";
import CreateCurrencyModal from "./components/CreateCurrencyModal";
import { useSelector } from "react-redux";
import { CurrencyContext } from "../../context/Context";
import { getCurrencyName } from "../../helpers/currencyConversion";

const ExchangeConfig = () => {
  const { baseCurrency } = useContext(CurrencyContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCurrency, setIsOpenCurrency] = useState(false);
  const { selectedCondominium } = useSelector((state) => state.condominium);

  /*     const [params] = useState(null); */

  const [params, setParams] = useState({
    condominium_id: selectedCondominium,
  });
  const [selected, setSelected] = useState(null);

  const {
    data: currencies,
    error,
    isLoading,
    mutate,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(findAllCurrencies, params);

  const [exchangeParams, setExchangeParams] = useState({
    currency: null,
  });

  const { currency } = exchangeParams;
  const {
    data,
    error: err,
    isLoading: loading,
    mutate: mut,
    meta: met,
    handler: {
      nextPage: nextPageEx,
      previousPage: previousPageEx,
      perPage: perPageEx,
      goToPage: goToPageEx,
    },
  } = useSWRFetchPagination(findAllExchangeRates, exchangeParams);

  return (
    <Fragment>
      <PageHeader
        title="Tasas de cambio"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
        description={`Gestiona tus tasas de cambio. Ten en cuenta que la moneda de trabajo de este condominio es ${getCurrencyName(
          baseCurrency?.iso
        )} (${baseCurrency?.symbol || "$"}), si es la primera vez que entras aquí asegúrate de configurar la tasa de cambios con las demás monedas.`}
      />
      <Card className={classNames({ "mb-3": isIterableArray(currencies) })}>
        <CardHeader
          className="bg-light"
          tag={Flex}
          align="center"
          justify="between"
        >
          <h5 className="mb-0">Monedas</h5>
          {/* <Flex align="center" justify="center">
            <ButtonIcon
              size="md"
              color="falcon-default"
              className="mr-2"
              icon={faPlus}
              onClick={() => setIsOpenCurrency(true)}
            >
              Añadir moneda
            </ButtonIcon>
          </Flex> */}
        </CardHeader>
        <CardBody
          className={classNames("fs--1", {
            "p-0": isIterableArray(currencies),
          })}
        >
          <Alert color="info" className="text-center mb-0">
            Debes seleccionar una moneda para conocer la tasa de cambio.
          </Alert>
          <PreloadState
            cond={!!isIterableArray(currencies)}
            loading={isLoading}
          >
            <Or value={true}>
              <Table className="mb-0">
                <thead>
                  <tr>
                    <th className="align-middle w-25">Moneda</th>
                    <th className="align-middle text-center">ISO</th>
                    <th className="align-middle text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currencies.map((val, i) => (
                    <CurrencyRow
                      setCurrency={(par) => {
                        setExchangeParams({ currency: par });
                      }}
                      setSelected={setSelected}
                      openModal={setIsOpenCurrency}
                      currency={currency}
                      key={i}
                      {...val}
                    />
                  ))}
                </tbody>
              </Table>
            </Or>
            <Or cond={!!error} value={false}>
              <Or value={false}>
                <Message
                  className="py-3 fs--1"
                  color="info"
                  icon={faExclamationCircle}
                >
                  No hay monedas para mostrar.
                </Message>
              </Or>
              <Or value={true}>
                <Message
                  className="py-3 fs--1"
                  color="danger"
                  icon={faExclamationCircle}
                >
                  Ha ocurrido un error.
                </Message>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        {isIterableArray(currencies) && (
          <CardFooter className="border-top">
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"monedas"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
      {!!currency && (
        <Card>
          <CardHeader
            className="bg-light"
            tag={Flex}
            align="center"
            justify="between"
          >
            <h5 className="mb-0">Tasas de cambio</h5>
            <Flex align="center" justify="center">
              <ButtonIcon
                size="md"
                color="falcon-default"
                className="mr-2"
                icon={faPlus}
                onClick={() => setIsOpen(true)}
              >
                Añadir tasa de cambio
              </ButtonIcon>
            </Flex>
          </CardHeader>
          <CardBody
            className={classNames("fs--1", { "p-0": isIterableArray(data) })}
          >
            <PreloadState cond={!!isIterableArray(data)} loading={loading}>
              <Or value={true}>
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th className="align-middle text-left">Tasa de cambio</th>
                      <th className="align-middle text-left">Fecha de tasa</th>
                      <th className="align-middle text-left">Fecha de creación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((val, i) => (
                      <ExchangeRateRow key={i} baseCurrency={baseCurrency} {...val} />
                    ))}
                  </tbody>
                </Table>
              </Or>
              <Or cond={!!err} value={false}>
                <Or value={false}>
                  <Message
                    className="py-3 fs--1"
                    color="info"
                    icon={faExclamationCircle}
                  >
                    No hay tasas de cambio para mostrar.
                  </Message>
                </Or>
                <Or value={true}>
                  <Message
                    className="py-3 fs--1"
                    color="danger"
                    icon={faExclamationCircle}
                  >
                    Ha ocurrido un error.
                  </Message>
                </Or>
              </Or>
            </PreloadState>
          </CardBody>
          {isIterableArray(data) && (
            <CardFooter className="border-top">
              <FullPagination
                nextPage={nextPageEx}
                prevPage={previousPageEx}
                goToPage={goToPageEx}
                meta={met}
                className={"shadow-none"}
                posText={"tasas de cambio"}
                perPage={perPageEx}
              />
            </CardFooter>
          )}
        </Card>
      )}

      <CreateExhangeRateModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        currency={selected}
        baseCurrency={baseCurrency}
        mutate={mut}
      />
      <CreateCurrencyModal
        isOpen={isOpenCurrency}
        setIsOpen={setIsOpenCurrency}
        currency={selected}
        mutate={mutate}
      />
    </Fragment>
  );
};

export default ExchangeConfig;
